import { render, staticRenderFns } from "./mainApp.vue?vue&type=template&id=031feb44&"
import script from "./mainApp.vue?vue&type=script&lang=js&"
export * from "./mainApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports